import e, { useState as n, useEffect as t } from "react";
function r(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var t = 0, r = Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function o(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != t) {
      var r,
        o,
        a,
        i,
        c = [],
        u = !0,
        l = !1;
      try {
        if (a = (t = t.call(e)).next, 0 === n) {
          if (Object(t) !== t) return;
          u = !1;
        } else for (; !(u = (r = a.call(t)).done) && (c.push(r.value), c.length !== n); u = !0);
      } catch (e) {
        l = !0, o = e;
      } finally {
        try {
          if (!u && null != t.return && (i = t.return(), Object(i) !== i)) return;
        } finally {
          if (l) throw o;
        }
      }
      return c;
    }
  }(e, n) || function (e, n) {
    if (e) {
      if ("string" == typeof e) return r(e, n);
      var t = {}.toString.call(e).slice(8, -1);
      return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? r(e, n) : void 0;
    }
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function a(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var i,
  c = {
    exports: {}
  },
  u = {
    exports: {}
  },
  l = {};
var s,
  f,
  p,
  d,
  m,
  y,
  b,
  h,
  g,
  v,
  S,
  _,
  w,
  x,
  E = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function O() {
  return f || (f = 1, "production" === process.env.NODE_ENV ? u.exports = function () {
    if (i) return l;
    i = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      c = e ? Symbol.for("react.provider") : 60109,
      u = e ? Symbol.for("react.context") : 60110,
      s = e ? Symbol.for("react.async_mode") : 60111,
      f = e ? Symbol.for("react.concurrent_mode") : 60111,
      p = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      m = e ? Symbol.for("react.suspense_list") : 60120,
      y = e ? Symbol.for("react.memo") : 60115,
      b = e ? Symbol.for("react.lazy") : 60116,
      h = e ? Symbol.for("react.block") : 60121,
      g = e ? Symbol.for("react.fundamental") : 60117,
      v = e ? Symbol.for("react.responder") : 60118,
      S = e ? Symbol.for("react.scope") : 60119;
    function _(e) {
      if ("object" == typeof e && null !== e) {
        var i = e.$$typeof;
        switch (i) {
          case n:
            switch (e = e.type) {
              case s:
              case f:
              case r:
              case a:
              case o:
              case d:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case u:
                  case p:
                  case b:
                  case y:
                  case c:
                    return e;
                  default:
                    return i;
                }
            }
          case t:
            return i;
        }
      }
    }
    function w(e) {
      return _(e) === f;
    }
    return l.AsyncMode = s, l.ConcurrentMode = f, l.ContextConsumer = u, l.ContextProvider = c, l.Element = n, l.ForwardRef = p, l.Fragment = r, l.Lazy = b, l.Memo = y, l.Portal = t, l.Profiler = a, l.StrictMode = o, l.Suspense = d, l.isAsyncMode = function (e) {
      return w(e) || _(e) === s;
    }, l.isConcurrentMode = w, l.isContextConsumer = function (e) {
      return _(e) === u;
    }, l.isContextProvider = function (e) {
      return _(e) === c;
    }, l.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, l.isForwardRef = function (e) {
      return _(e) === p;
    }, l.isFragment = function (e) {
      return _(e) === r;
    }, l.isLazy = function (e) {
      return _(e) === b;
    }, l.isMemo = function (e) {
      return _(e) === y;
    }, l.isPortal = function (e) {
      return _(e) === t;
    }, l.isProfiler = function (e) {
      return _(e) === a;
    }, l.isStrictMode = function (e) {
      return _(e) === o;
    }, l.isSuspense = function (e) {
      return _(e) === d;
    }, l.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === f || e === a || e === o || e === d || e === m || "object" == typeof e && null !== e && (e.$$typeof === b || e.$$typeof === y || e.$$typeof === c || e.$$typeof === u || e.$$typeof === p || e.$$typeof === g || e.$$typeof === v || e.$$typeof === S || e.$$typeof === h);
    }, l.typeOf = _, l;
  }() : u.exports = (s || (s = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      c = e ? Symbol.for("react.context") : 60110,
      u = e ? Symbol.for("react.async_mode") : 60111,
      l = e ? Symbol.for("react.concurrent_mode") : 60111,
      s = e ? Symbol.for("react.forward_ref") : 60112,
      f = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      d = e ? Symbol.for("react.memo") : 60115,
      m = e ? Symbol.for("react.lazy") : 60116,
      y = e ? Symbol.for("react.block") : 60121,
      b = e ? Symbol.for("react.fundamental") : 60117,
      h = e ? Symbol.for("react.responder") : 60118,
      g = e ? Symbol.for("react.scope") : 60119;
    function v(e) {
      if ("object" == typeof e && null !== e) {
        var p = e.$$typeof;
        switch (p) {
          case n:
            var y = e.type;
            switch (y) {
              case u:
              case l:
              case r:
              case a:
              case o:
              case f:
                return y;
              default:
                var b = y && y.$$typeof;
                switch (b) {
                  case c:
                  case s:
                  case m:
                  case d:
                  case i:
                    return b;
                  default:
                    return p;
                }
            }
          case t:
            return p;
        }
      }
    }
    var S = u,
      _ = l,
      w = c,
      x = i,
      O = n,
      j = s,
      R = r,
      $ = m,
      T = d,
      P = t,
      C = a,
      N = o,
      k = f,
      I = !1;
    function A(e) {
      return v(e) === l;
    }
    E.AsyncMode = S, E.ConcurrentMode = _, E.ContextConsumer = w, E.ContextProvider = x, E.Element = O, E.ForwardRef = j, E.Fragment = R, E.Lazy = $, E.Memo = T, E.Portal = P, E.Profiler = C, E.StrictMode = N, E.Suspense = k, E.isAsyncMode = function (e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(e) || v(e) === u;
    }, E.isConcurrentMode = A, E.isContextConsumer = function (e) {
      return v(e) === c;
    }, E.isContextProvider = function (e) {
      return v(e) === i;
    }, E.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, E.isForwardRef = function (e) {
      return v(e) === s;
    }, E.isFragment = function (e) {
      return v(e) === r;
    }, E.isLazy = function (e) {
      return v(e) === m;
    }, E.isMemo = function (e) {
      return v(e) === d;
    }, E.isPortal = function (e) {
      return v(e) === t;
    }, E.isProfiler = function (e) {
      return v(e) === a;
    }, E.isStrictMode = function (e) {
      return v(e) === o;
    }, E.isSuspense = function (e) {
      return v(e) === f;
    }, E.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === l || e === a || e === o || e === f || e === p || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === d || e.$$typeof === i || e.$$typeof === c || e.$$typeof === s || e.$$typeof === b || e.$$typeof === h || e.$$typeof === g || e.$$typeof === y);
    }, E.typeOf = v;
  }()), E)), u.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function j() {
  if (d) return p;
  d = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    t = Object.prototype.propertyIsEnumerable;
  return p = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, t = 0; t < 10; t++) n["_" + String.fromCharCode(t)] = t;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (r, o) {
    for (var a, i, c = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(r), u = 1; u < arguments.length; u++) {
      for (var l in a = Object(arguments[u])) n.call(a, l) && (c[l] = a[l]);
      if (e) {
        i = e(a);
        for (var s = 0; s < i.length; s++) t.call(a, i[s]) && (c[i[s]] = a[i[s]]);
      }
    }
    return c;
  }, p;
}
function R() {
  if (y) return m;
  y = 1;
  return m = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function $() {
  return h ? b : (h = 1, b = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var T = O();
  c.exports = function () {
    if (_) return S;
    _ = 1;
    var e = O(),
      n = j(),
      t = R(),
      r = $(),
      o = function () {
        if (v) return g;
        v = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = R(),
            t = {},
            r = $();
          e = function e(_e) {
            var n = "Warning: " + _e;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function o(o, a, i, c, u) {
          if ("production" !== process.env.NODE_ENV) for (var l in o) if (r(o, l)) {
            var s;
            try {
              if ("function" != typeof o[l]) {
                var f = Error((c || "React class") + ": " + i + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw f.name = "Invariant Violation", f;
              }
              s = o[l](a, l, c, i, null, n);
            } catch (e) {
              s = e;
            }
            if (!s || s instanceof Error || e((c || "React class") + ": type specification of " + i + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in t)) {
              t[s.message] = !0;
              var p = u ? u() : "";
              e("Failed " + i + " type: " + s.message + (null != p ? p : ""));
            }
          }
        }
        return o.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (t = {});
        }, g = o;
      }(),
      a = function a() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), S = function S(c, u) {
      var l = "function" == typeof Symbol && Symbol.iterator,
        s = "@@iterator",
        f = "<<anonymous>>",
        p = {
          array: b("array"),
          bigint: b("bigint"),
          bool: b("boolean"),
          func: b("function"),
          number: b("number"),
          object: b("object"),
          string: b("string"),
          symbol: b("symbol"),
          any: y(i),
          arrayOf: function arrayOf(e) {
            return y(function (n, r, o, a, i) {
              if ("function" != typeof e) return new m("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
              var c = n[r];
              if (!Array.isArray(c)) return new m("Invalid " + a + " `" + i + "` of type `" + v(c) + "` supplied to `" + o + "`, expected an array.");
              for (var u = 0; u < c.length; u++) {
                var l = e(c, u, o, a, i + "[" + u + "]", t);
                if (l instanceof Error) return l;
              }
              return null;
            });
          },
          element: y(function (e, n, t, r, o) {
            var a = e[n];
            return c(a) ? null : new m("Invalid " + r + " `" + o + "` of type `" + v(a) + "` supplied to `" + t + "`, expected a single ReactElement.");
          }),
          elementType: y(function (n, t, r, o, a) {
            var i = n[t];
            return e.isValidElementType(i) ? null : new m("Invalid " + o + " `" + a + "` of type `" + v(i) + "` supplied to `" + r + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return y(function (n, t, r, o, a) {
              if (!(n[t] instanceof e)) {
                var i = e.name || f;
                return new m("Invalid " + o + " `" + a + "` of type `" + ((c = n[t]).constructor && c.constructor.name ? c.constructor.name : f) + "` supplied to `" + r + "`, expected instance of `" + i + "`.");
              }
              var c;
              return null;
            });
          },
          node: y(function (e, n, t, r, o) {
            return g(e[n]) ? null : new m("Invalid " + r + " `" + o + "` supplied to `" + t + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return y(function (n, o, a, i, c) {
              if ("function" != typeof e) return new m("Property `" + c + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var u = n[o],
                l = v(u);
              if ("object" !== l) return new m("Invalid " + i + " `" + c + "` of type `" + l + "` supplied to `" + a + "`, expected an object.");
              for (var s in u) if (r(u, s)) {
                var f = e(u, s, a, i, c + "." + s, t);
                if (f instanceof Error) return f;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? y(function (n, t, r, o, a) {
              for (var i = n[t], c = 0; c < e.length; c++) if (d(i, e[c])) return null;
              var u = JSON.stringify(e, function (e, n) {
                return "symbol" === S(n) ? String(n) : n;
              });
              return new m("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + r + "`, expected one of " + u + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              if ("function" != typeof o) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + _(o) + " at index " + n + "."), i;
            }
            return y(function (n, o, a, i, c) {
              for (var u = [], l = 0; l < e.length; l++) {
                var s = (0, e[l])(n, o, a, i, c, t);
                if (null == s) return null;
                s.data && r(s.data, "expectedType") && u.push(s.data.expectedType);
              }
              return new m("Invalid " + i + " `" + c + "` supplied to `" + a + "`" + (u.length > 0 ? ", expected one of type [" + u.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return y(function (n, r, o, a, i) {
              var c = n[r],
                u = v(c);
              if ("object" !== u) return new m("Invalid " + a + " `" + i + "` of type `" + u + "` supplied to `" + o + "`, expected `object`.");
              for (var l in e) {
                var s = e[l];
                if ("function" != typeof s) return h(o, a, i, l, S(s));
                var f = s(c, l, o, a, i + "." + l, t);
                if (f) return f;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return y(function (o, a, i, c, u) {
              var l = o[a],
                s = v(l);
              if ("object" !== s) return new m("Invalid " + c + " `" + u + "` of type `" + s + "` supplied to `" + i + "`, expected `object`.");
              var f = n({}, o[a], e);
              for (var p in f) {
                var d = e[p];
                if (r(e, p) && "function" != typeof d) return h(i, c, u, p, S(d));
                if (!d) return new m("Invalid " + c + " `" + u + "` key `" + p + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(o[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var y = d(l, p, i, c, u + "." + p, t);
                if (y) return y;
              }
              return null;
            });
          }
        };
      function d(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function m(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function y(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          r = 0;
        function o(o, i, c, l, s, p, d) {
          if (l = l || f, p = p || c, d !== t) {
            if (u) {
              var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw y.name = "Invariant Violation", y;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var b = l + ":" + c;
              !n[b] && r < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[b] = !0, r++);
            }
          }
          return null == i[c] ? o ? null === i[c] ? new m("The " + s + " `" + p + "` is marked as required in `" + l + "`, but its value is `null`.") : new m("The " + s + " `" + p + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(i, c, l, s, p);
        }
        var i = o.bind(null, !1);
        return i.isRequired = o.bind(null, !0), i;
      }
      function b(e) {
        return y(function (n, t, r, o, a, i) {
          var c = n[t];
          return v(c) !== e ? new m("Invalid " + o + " `" + a + "` of type `" + S(c) + "` supplied to `" + r + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function h(e, n, t, r, o) {
        return new m((e || "React class") + ": " + n + " type `" + t + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }
      function g(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(g);
            if (null === e || c(e)) return !0;
            var n = function (e) {
              var n = e && (l && e[l] || e[s]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var t,
              r = n.call(e);
            if (n !== e.entries) {
              for (; !(t = r.next()).done;) if (!g(t.value)) return !1;
            } else for (; !(t = r.next()).done;) {
              var o = t.value;
              if (o && !g(o[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function v(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function S(e) {
        if (null == e) return "" + e;
        var n = v(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function _(e) {
        var n = S(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return m.prototype = Error.prototype, p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
    }, S;
  }()(T.isElement, !0);
} else c.exports = function () {
  if (x) return w;
  x = 1;
  var e = R();
  function n() {}
  function t() {}
  return t.resetWarningCache = n, w = function w() {
    function r(n, t, r, o, a, i) {
      if (i !== e) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }
    function o() {
      return r;
    }
    r.isRequired = r;
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  };
}()();
var P = a(c.exports);
var C = "SmartBadge-module_smart-banner-container__rRuEK",
  N = "SmartBadge-module_hide__3Hf3f";
function k(r) {
  var a = r.label,
    i = r.hide,
    c = r.url,
    u = r.onCloseBanner,
    l = o(n(i), 2),
    s = l[0],
    f = l[1],
    p = s ? C + " " + N : C;
  return t(function () {
    f(i);
  }, [i]), e.createElement("div", {
    className: p
  }, e.createElement("span", null, e.createElement("em", null, a)), e.createElement("span", null, e.createElement("a", {
    href: c
  }, "Download now"), e.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      return function (e) {
        e.preventDefault(), i || f(!0), u();
      }(e);
    },
    className: "btn-close"
  })));
}
!function (e, n) {
  void 0 === n && (n = {});
  var t = n.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
    o.type = "text/css", "top" === t && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('.SmartBadge-module_smart-banner-container__rRuEK {\n  border-radius: 12px;\n  background-color: #002b49;\n  color: white;\n  font-family: "protipo-narrow";\n  padding: 8px;\n  line-height: 1;\n  position: fixed;\n  width: calc(100% - 16px);\n  left: 8px;\n  right: 8px;\n  bottom: 8px;\n  min-width: 290px;\n}\n.SmartBadge-module_smart-banner-container__rRuEK.SmartBadge-module_hide__3Hf3f {\n  display: none;\n}\n.SmartBadge-module_smart-banner-container__rRuEK span {\n  font-weight: 700;\n  font-size: 14px;\n  display: inline-block;\n}\n.SmartBadge-module_smart-banner-container__rRuEK span:first-child {\n  width: 60%;\n  vertical-align: top;\n}\n.SmartBadge-module_smart-banner-container__rRuEK span:first-child em {\n  vertical-align: top;\n  line-height: 16px;\n  width: 140px;\n  display: inline-block;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.SmartBadge-module_smart-banner-container__rRuEK span:first-child::before {\n  content: " ";\n  width: 40px;\n  height: 40px;\n  display: inline-block;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g id="app-icon" transform="translate(2441 -536)"><rect id="Rectangle_4336" data-name="Rectangle 4336" width="40" height="40" rx="8" transform="translate(-2441 536)" fill="%23fff"/><g id="SN-dark" transform="translate(-2436.833 547.667)"><path id="path" d="M71.331,125.467c2.579-2.619,8.751-.251,9.4-.323.322-.036.478-.514-.155-.765a43.219,43.219,0,0,0-20.152-2.164c-.537.155-.728.634.131.729a47.821,47.821,0,0,1,6.244,1.016,16.059,16.059,0,0,1,4.143,1.59c.107.072.227.036.394-.084" transform="translate(-52.809 -107.254)" fill="%23005cb9"/><path id="path-2" data-name="path" d="M28.474,99.308l.513-2.487a43.661,43.661,0,0,0-28.557.706c-.478.155-.633.9.346.729a103.223,103.223,0,0,1,12.93-1.088A46.086,46.086,0,0,1,27.615,99.5C28.128,99.655,28.379,99.6,28.474,99.308Z" transform="translate(-0.055 -83.427)" fill="%23e1251b"/><g id="group" transform="translate(0.878)"><path id="path-3" data-name="path" d="M138.443,2.4l-1.564,7.366h-.036L134.718,2.4h-7.927l-.7,3.289h1.146L125.8,12.421h.633c1.11,0,2.233.036,3.343.132L131.244,5.6h.036l2.161,7.366a49.708,49.708,0,0,1,6.435,1.495h.036L142.455,2.4Z" transform="translate(-111.666 -2.113)"/><path id="path-4" data-name="path" d="M21.292,3.576C21.71,1.3,20.563,0,15.907,0,11.514,0,9.067,1.088,8.553,3.48a2.058,2.058,0,0,0,.382,1.913c1.218,1.3,6.339,1.818,6.817,2.511a.676.676,0,0,1,.1.514c-.191.9-1.277,1.112-2.233,1.112a1.531,1.531,0,0,1-1.242-.442,1.638,1.638,0,0,1-.131-1.339h-4.7c-.322,1.877-.418,3.576,4.358,3.791a40.942,40.942,0,0,1,7.032-1.112A3.715,3.715,0,0,0,20.743,8,2.144,2.144,0,0,0,20.3,5.955c-1.17-1.3-6.136-1.782-6.71-2.475a.676.676,0,0,1-.1-.514c.131-.574.7-.921,1.683-.921a1.78,1.78,0,0,1,1.277.323,1.185,1.185,0,0,1,.322,1.208Z" transform="translate(-7.408 0)"/></g></g></g></svg>\') center center no-repeat;\n  margin-right: 12px;\n}\n.SmartBadge-module_smart-banner-container__rRuEK span:last-child {\n  width: 40%;\n  font-style: normal;\n  float: right;\n  text-align: right;\n}\n.SmartBadge-module_smart-banner-container__rRuEK a {\n  font-size: 14px;\n  font-weight: 400;\n  color: #5bc2e7;\n  display: inline-block;\n  text-decoration: none;\n  vertical-align: middle;\n  height: 40px;\n  line-height: 40px;\n}\n.SmartBadge-module_smart-banner-container__rRuEK a:active, .SmartBadge-module_smart-banner-container__rRuEK a:visited, .SmartBadge-module_smart-banner-container__rRuEK a:hover, .SmartBadge-module_smart-banner-container__rRuEK a:focus {\n  text-decoration: none;\n}\n.SmartBadge-module_smart-banner-container__rRuEK a:last-child {\n  margin-left: 16px;\n  display: inline-block;\n  content: " ";\n  width: 24px;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g id="Group_8313" data-name="Group 8313" transform="translate(-341 -677)" opacity="0.4"><rect id="Rectangle_6" data-name="Rectangle 6" width="24" height="24" transform="translate(341 677)" fill="none"/><path id="Icon_material-close" data-name="Icon material-close" d="M19.5,8.709,18.291,7.5,13.5,12.291,8.709,7.5,7.5,8.709,12.291,13.5,7.5,18.291,8.709,19.5,13.5,14.709,18.291,19.5,19.5,18.291,14.709,13.5Z" transform="translate(339.5 675.5)" fill="%23fff"/></g></svg>\') center center no-repeat;\n}\n@media screen and (max-width: 375px) {\n  .SmartBadge-module_smart-banner-container__rRuEK span, .SmartBadge-module_smart-banner-container__rRuEK a {\n    font-size: 12px;\n  }\n  .SmartBadge-module_smart-banner-container__rRuEK a:last-child {\n    margin-left: 5px;\n  }\n  .SmartBadge-module_smart-banner-container__rRuEK span:first-child em {\n    width: 100px;\n  }\n}'), k.propTypes = {
  label: P.string.isRequired,
  hide: P.bool.isRequired,
  url: P.string.isRequired,
  onCloseBanner: P.func
}, k.defaultProps = {
  label: "GET THE ALL NEW SPORTSNET APP",
  hide: !1,
  url: "https://itunes.apple.com/app/apple-store/id602321016?pt=205834&ct=SNDownloadAppButton&mt=8",
  onCloseBanner: function onCloseBanner() {}
};
export { k as SmartBanner };